import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginWithEmailAndPassword, onAuthStateChange } from '../services/auth';
import { Button, Card, Field } from '../components/ui';
import logo from '../assets/icon.png';

export default function LoginPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChange((user) => {
      if (user) navigate('/', { replace: true });
    });
    return unsubscribe;
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const result = await loginWithEmailAndPassword(form);
    setBusy(false);
    if (result.success) {
      navigate('/', { replace: true });
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="login-shell">
      <Card className="login-card">
        <div className="brand login-brand">
          <img src={logo} alt="PrepGen logo" className="brand-logo" />
          <span>Prepgen.ai<small>for Institutes</small></span>
        </div>
        <h1>Welcome back</h1>
        <p className="muted">Sign in with your institute owner account.</p>
        <form className="form" onSubmit={handleSubmit}>
          <Field label="Email">
            <input type="email" autoComplete="email" placeholder="you@institute.com" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </Field>
          <Field label="Password">
            <span className="password-wrap">
              <input type={showPassword ? 'text' : 'password'} autoComplete="current-password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })} />
              <button type="button" className="toggle" onClick={() => setShowPassword((v) => !v)}>
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </span>
          </Field>
          {error && <p className="login-error">{error}</p>}
          <Button type="submit" disabled={busy || !form.email || !form.password}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
          <p className="muted">New here? <Link to="/signup">Create your institute</Link></p>
        </form>
      </Card>
    </div>
  );
}
